export const COMPANY_MANDANTE_RELATION = 'mandante' as const;

export function normalizeCompanyRelationTag(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLocaleLowerCase('it-IT')
    .replace(/[\s_-]+/g, '');
}

export function isCompanyMandante(relations: unknown): boolean {
  return Array.isArray(relations)
    && relations.some((relation) => normalizeCompanyRelationTag(relation) === COMPANY_MANDANTE_RELATION);
}
